import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getInspectionItems, saveInspectedItems } from "../../store/Slices/TripSlice";
import "../../styles/Trip.css";
import SpinnerLoader from "../../utils/SpinnerLoader";

const TripInspection = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [preAnswers, setPreAnswers] = useState({});
  const [postAnswers, setPostAnswers] = useState({});

  const { inspectionItemsLoading, inspectionItemsData, tripDetailsData } = useSelector((state) => state.trips)

  useEffect(() => {
    dispatch(getInspectionItems({ trip_id: id }));
  }, [dispatch, id]);

  const handlePreInspection = (type, inspection_id, inspection_type) => {
    if (inspection_type === "pre_inspection") {
      setPreAnswers((prev) => ({ ...prev, [inspection_id]: type }));
    } else {
      setPostAnswers((prev) => ({ ...prev, [inspection_id]: type }));
    }

    const payload = {
      "vehicle_id": tripDetailsData?.vehicle_id,
      "trip_id": id,
      "inspection_item_id": inspection_id,
      "answer": type,
      "inspection_type": inspection_type
    }

    dispatch(saveInspectedItems(payload)).unwrap();
  }

  return (
    <div className="inspection_wrap">
      {
        inspectionItemsLoading ? <SpinnerLoader /> :
          <>
            <div className="inspection_card">
              <div className="inspection_header">
                <h5>Pre Inspection Questionnaire</h5>
                <p>Main information for this trip record.</p>
              </div>

              <div className="inspection_table">
                {inspectionItemsData?.pre_inspection_items?.map((q, idx) => (
                  <div className="inspection_row" key={idx}>
                    <span className="ins_no">{String(idx + 1).padStart(2, "0")}</span>
                    <span className="ins_question">{q.title}</span>
                    <div className="ins_actions">
                      <button type="button" onClick={() => handlePreInspection("agree", q?.id, "pre_inspection")} className={`ins_btn ${(preAnswers[q?.id] || q?.pre_inspected_item?.answer) === "agree" ? "primary" : ""}`}>Agree</button>
                      <button type="button" onClick={() => handlePreInspection("partial_agree", q?.id, "pre_inspection")} className={`ins_btn ${(preAnswers[q?.id] || q?.pre_inspected_item?.answer) === "partial_agree" ? "primary" : ""}`}>Partially Agree</button>
                      <button type="button" onClick={() => handlePreInspection("disagree", q?.id, "pre_inspection")} className={`ins_btn ${(preAnswers[q?.id] || q?.pre_inspected_item?.answer) === "disagree" ? "primary" : ""}`}>Disagree</button>
                      <button type="button" onClick={() => handlePreInspection("dont_know", q?.id, "pre_inspection")} className={`ins_btn ${(preAnswers[q?.id] || q?.pre_inspected_item?.answer) === "dont_know" ? "primary" : ""}`}>Don't Know</button>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="inspection_card">
              <div className="inspection_header">
                <h5>Post Inspection Check List</h5>
                <p>Main information for this trip record.</p>
              </div>

              <div className="inspection_table">
                {inspectionItemsData?.post_inspection_items?.map((q, idx) => (
                  <div className="inspection_row" key={idx}>
                    <span className="ins_no">{String(idx + 1).padStart(2, "0")}</span>
                    <span className="ins_question">{q.title}</span>
                    <div className="ins_actions">
                      <button type="button" onClick={() => handlePreInspection("agree", q?.id, "post_inspection")} className={`ins_btn ${(postAnswers[q?.id] || q?.post_inspected_item?.answer) === "agree" ? "primary" : ""}`}>Agree</button>
                      <button type="button" onClick={() => handlePreInspection("partial_agree", q?.id, "post_inspection")} className={`ins_btn ${(postAnswers[q?.id] || q?.post_inspected_item?.answer) === "partial_agree" ? "primary" : ""}`}>Partially Agree</button>
                      <button type="button" onClick={() => handlePreInspection("disagree", q?.id, "post_inspection")} className={`ins_btn ${(postAnswers[q?.id] || q?.post_inspected_item?.answer) === "disagree" ? "primary" : ""}`}>Disagree</button>
                      <button type="button" onClick={() => handlePreInspection("dont_know", q?.id, "post_inspection")} className={`ins_btn ${(postAnswers[q?.id] || q?.post_inspected_item?.answer) === "dont_know" ? "primary" : ""}`}>Don't Know</button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </>
      }
    </div>
  );
};

export default TripInspection;
